export default {
  image: {
    'ui:widget': 'EditorUploadWidget',
    'ui:options': {
      maxSize: 3,
    },
  },
}
